D.Blog = {
	inScreen( el ) {
		const rect = el.getBoundingClientRect();
		return (
			rect.height > 0 &&
			rect.width > 0 &&
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}
};

const SectionBlog = Class(
	/**
	 * @lends {SectionBlog#}
	 */
	{
		route() {
			const part = this.url.shift();
			if( part === String(parseInt(part)) ) {
				return new SectionBlog.BlogItem;
			}
			return new SectionBlog.Blog;
		}
	},
	Section
);

/**
 * @class
 * @extends Section
 */
SectionBlog.Base = Class(
	/**
	 * @lends {SectionBlog.Base#}
	 */
	{
		bodyClass: 'small-nav blog',
		background: 0,
		menuItem: 'blog',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'blog',
				className: 'SectionBlog'
			}).append(this.layout.ct());
		}
	},
	Section
);

/**
 * @class
 * @extends SectionBlog.Base
 */
SectionBlog.Blog = Class(
	/**
	 * @lends {SectionBlog.Blog#}
	 */
	{
		draw() {
			mkE({
				tag: 'div',
				id: 'blog-hero',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'h1',
								text: D.Lang.get('blog.h1', 'Roadgames Blog')
							},
							{
								tag: 'div',
								className: 'content',
								els: [
									this._heroPost = mkE({
										tag: 'div',
										className: 'blog-hero-post'
									}),
									new D.Blog.NewsLetterForm()
								]
							}
						]
					}
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				className: '',
				els: [
					this._postsNode = mkE({
						tag: 'div',
						className: 'blog-posts'
					}),
					this._loadMore = mkE({
						tag: 'div',
						className: 'load-more',
						els: [
							{
								tag: 'a',
								className: 'button button-turquoise',
								text: D.Lang.get('blogs.loadMore'),
								onclick: this.loadMore
							}
						]
					})
				]
			}).append(this.node);

			this._mGetItems = new DR.blog.GetItems();
			this._mGetItems.pg = 1;
			this._mGetItems.count = 4;
			this._mGetItems.select = [
				new DR.blog.select.Item().all(),
				new DR.roadgames.select.Image().all(),
				new DR.blog.select.Author().name()
			];
			this._mGetItems.onLoad = this._mGetItemsRe;
			this.apiCall.addMethod(this._mGetItems);

			this.apiCall.call();
		},

		_mGetItemsRe() {
			if( !this._mGetItems.re.items.length ) {
				Section.navigate(D.url('/'));
				return;
			}

			if( this._mGetItems.pg === 1 ) {
				const item = this._mGetItems.re.items.splice(0, 1)[0];
				new D.Blog.PostHero(item).append(this._heroPost);
			}

			for( let i = 0; i < this._mGetItems.re.items.length; i++ ) {
				const item = this._mGetItems.re.items[i];
				new D.Blog.PostHorizontal(item).append(this._postsNode);
			}

			if( this._mGetItems.pg === 1 ) {
				new SectionHome.EventTypes().append(this._postsNode);
			}

			if( this._mGetItems.pg >= this._mGetItems.re.pgs ) {
				this._loadMore.remove();
				this._loadMore = null;
			}
		},

		loadMore() {
			if( this._mGetItems.processing ) {
				return;
			}
			if( this._mGetItems.pg >= this._mGetItems.re.pgs ) {
				this._loadMore.remove();
				this._loadMore = null;
				return;
			}
			this._mGetItems.pg++;
			this._mGetItems.call();
		},

		onScroll() {
			if( this._loadMore && D.Blog.inScreen(this._loadMore) ) {
				this.loadMore();
			}
		}
	},
	SectionBlog.Base
);

/**
 * @class
 * @extends SectionBlog.Base
 */
SectionBlog.BlogItem = Class(
	/**
	 * @lends {SectionBlog.BlogItem#}
	 */
	{
		route() {
			this.id = +this.url.before;
		},

		draw() {
			mkE({
				tag: 'div',
				className: 'BlogItem',
				els: [
					this._itemNode = mkE({
						tag: 'div',
						className: 'container'
					}),
					{
						tag: 'div',
						className: 'contact container',
						els: [
							new D.Blog.ContactForm()
						]
					},
					this._relatedItemsNode = mkE({
						tag: 'div',
						className: 'related-posts'
					}),
					{
						tag: 'div',
						className: 'newsletter-footer',
						els: [
							new D.Blog.NewsLetterForm(true)
						]
					}
				]
			}).append(this.node);

			this._mGetItem = new DR.blog.GetItem();
			this._mGetItem.id = this.id;
			this._mGetItem.select = [
				new DR.blog.select.Item().all(),
				new DR.roadgames.select.Image().all(),
				new DR.blog.select.Author().all()
			];
			this._mGetItem.onLoad = this._mGetItemRe;
			this._mGetItem.onError = this._mGetItemErr;
			this.apiCall.addMethod(this._mGetItem);

			this._mGetRelated = new DR.blog.GetRelated();
			this._mGetRelated.id = this.id;
			this._mGetRelated.select = [
				new DR.blog.select.Item().all(),
				new DR.roadgames.select.Image().all(),
				new DR.blog.select.Author().name()
			];
			this._mGetRelated.onLoad = this._mGetRelatedRe;
			this.apiCall.addMethod(this._mGetRelated);

			this.apiCall.call();
		},

		_mGetItemErr() {
			Section.navigate(D.url('/blog'));
		},

		_mGetItemRe() {
			const item = this._mGetItem.re;
			this.title = item.title;
			this.description = item.intro;
			if( item.metaTitle ) {
				this.title = item.metaTitle;
				this.ogTitle = item.metaTitle;
			}
			if( item.metaDescription ) {
				this.description = item.metaDescription;
				this.ogDescription = item.metaDescription;
			}
			this.ogImage = item.cover.image.original;
			this.canonicalUrl = D.url(item.url, null, true);
			this.langs = [item.lang];
			//@todo remove alt href
			new D.Blog.PostFull(this._mGetItem.re).append(this._itemNode);
		},

		_mGetRelatedRe() {
			if( !this._mGetRelated.re.items.length ) {
				return;
			}

			let posts = [];
			for( let i = 0; i < this._mGetRelated.re.items.length; i++ ) {
				const item = this._mGetRelated.re.items[i];
				posts.push(new D.Blog.PostSmall(item));
			}

			mkE({
				tag: 'div',
				className: 'container',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('blog.related_posts')
					},
					{
						tag: 'div',
						className: 'items',
						els: posts
					}
				]
			}).append(this._relatedItemsNode);
		}
	},
	SectionBlog.Base
);

/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostHero = Class(
	/**
	 * @lends {D.Blog.PostHero#}
	 */
	{
		/** @type {DR.blog.struct.Item} */
		item: null,

		/** @param {DR.blog.struct.Item} item */
		__construct( item ) {
			this.item = item;

			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-hero',
				style: {
					backgroundImage: 'url(' + this.item.cover.image.large + ')'
				},
				els: [
					{
						tag: 'a',
						className: 'body',
						href: D.url(this.item.url),
						els: [
							{
								tag: 'section',
								className: 'tags',
								els: function () {
									let els = [];
									for( let i = 0; i < item.tags.length; i++ ) {
										const tag = item.tags[i];
										els.push({
											tag: 'span',
											// href: D.url('/blog/search/?tag=' + tag),
											text: tag
										});
									}
									return els;
								}()
							},
							{
								tag: 'h2',
								className: 'title',
								text: this.item.title
							},
							{
								tag: 'section',
								className: 'intro',
								text: this.item.intro
							},
							{
								tag: 'section',
								className: 'info',
								els: [
									{
										tag: 'time',
										attr: {
											datetime: new D.Date(this.item.pubDate).format('Y-m-d H:i:s')
										},
										text: new D.Date(this.item.pubDate).format(D.Lang.get('blog.date_format'))
									},
									' ',
									{
										tag: 'span',
										className: 'author',
										text: this.item.author.name
									},
									' ' + D.Lang.get('blog.author_preposition') + ' ',
									{
										tag: 'span',
										className: 'author',
										text: 'Roadgames'
									}
								]
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);


/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostHorizontal = Class(
	/**
	 * @lends {D.Blog.PostHorizontal#}
	 */
	{
		/** @type {DR.blog.struct.Item} */
		item: null,

		/** @param {DR.blog.struct.Item} item */
		__construct( item ) {
			this.item = item;

			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-horizontal container',
				els: [
					{
						tag: 'section',
						className: 'body',
						els: [
							{
								tag: 'section',
								className: 'tags',
								els: function () {
									let els = [];
									for( let i = 0; i < item.tags.length; i++ ) {
										const tag = item.tags[i];
										els.push({
											tag: 'span',
											// href: D.url('/blog/search/?tag=' + tag),
											text: tag
										});
									}
									return els;
								}()
							},
							{
								tag: 'h3',
								className: 'title',
								els: [
									{
										tag: 'a',
										href: D.url(this.item.url),
										text: this.item.title
									}
								]
							},
							{
								tag: 'section',
								className: 'info',
								els: [
									{
										tag: 'time',
										attr: {
											datetime: new D.Date(this.item.pubDate).format('Y-m-d H:i:s')
										},
										text: new D.Date(this.item.pubDate).format(D.Lang.get('blog.date_format'))
									},
									' ',
									{
										tag: 'span',
										className: 'author',
										text: this.item.author.name
									},
									' ' + D.Lang.get('blog.author_preposition') + ' ',
									{
										tag: 'span',
										className: 'author',
										text: 'Roadgames'
									}
								]
							}
						]
					},
					{
						tag: 'section',
						className: 'cover',
						els: [
							{
								tag: 'a',
								href: D.url(this.item.url),
								els: [
									{
										tag: 'img',
										alt: this.item.coverAltText || 'Cover image',
										src: this.item.cover.image.large
									}
								]
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);

/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostSmall = Class(
	/**
	 * @lends {D.Blog.PostSmall#}
	 */
	{
		/** @type {DR.blog.struct.Item} */
		item: null,

		/** @param {DR.blog.struct.Item} item */
		__construct( item ) {
			this.item = item;

			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-small',
				els: [
					{
						tag: 'div',
						className: 'cover',
						els: [
							{
								tag: 'a',
								href: D.url(this.item.url),
								els: [
									{
										tag: 'img',
										alt: this.item.coverAltText || 'Cover image',
										src: this.item.cover.image.large
									}
								]
							}
						]
					},
					{
						tag: 'h4',
						className: 'title',
						els: [
							{
								tag: 'a',
								href: D.url(this.item.url),
								text: this.item.title
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);

/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostFull = Class(
	/**
	 * @lends {D.Blog.PostFull#}
	 */
	{
		/** @param {DR.blog.struct.Item} item */
		__construct( item ) {
			this.item = item;

			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-full'
			});

			let els = [];
			for( let i = 0; i < item.tags.length; i++ ) {
				const tag = item.tags[i];
				els.push({
					tag: 'span',
					// href: D.url('/blog/search/?tag=' + tag),
					text: tag
				});
			}

			mkE({
				tag: 'section',
				className: 'tags',
				els: els
			}).append(this.node);

			mkE({
				tag: 'header',
				els: [
					{
						tag: 'h1',
						className: 'title',
						text: this.item.title
					}
				]
			}).append(this.node);

			mkE({
				tag: 'section',
				className: 'wrapper',
				els: [
					{
						tag: 'section',
						className: 'info',
						els: [
							{
								tag: 'div',
								className: 'author-image',
								style: {
									backgroundImage: 'url(' + this.item.author.image.small + ')'
								}
							},
							{
								tag: 'div',
								className: 'author-time',
								els: [
									{
										tag: 'time',
										attr: {
											datetime: new D.Date(this.item.pubDate).format('Y-m-d H:i:s')
										},
										text: new D.Date(this.item.pubDate).format(D.Lang.get('blog.date_format'))
									},
									{
										tag: 'div',
										className: 'author',
										els: [
											' ',
											{
												tag: 'span',
												text: this.item.author.name
											},
											' ' + D.Lang.get('blog.author_preposition') + ' ',
											{
												tag: 'span',
												text: 'Roadgames'
											}
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'share',
								els: [
									{
										tag: 'a',
										className: 'share-facebook',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlFacebook()
									},
									{
										tag: 'a',
										className: 'share-twitter',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlTwitter()
									},
									{
										tag: 'a',
										className: 'share-draugiem',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlDraugiem()
									},
									{
										tag: 'a',
										className: 'share-linkedin',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlLinkedIn()
									}
								]
							}
						]
					},
					{
						tag: 'section',
						className: 'body',
						els: [
							this.item.hasCover ? {
								tag: 'section',
								className: 'cover',
								els: [
									{
										tag: 'img',
										className: 'cover',
										alt: this.item.coverAltText || 'Cover image',
										src: this.item.cover.image.large
									}
								]
							} : '',
							{
								tag: 'section',
								className: 'ck-content',
								innerHTML: this.item.html
							}
						]
					}
				]
			}).append(this.node);

			this._drawFaq();
		},

		_drawFaq() {
			if( !this.item.qa || !this.item.qa.length ) {
				return;
			}

			let els = [];
			for( let i = 0; i < this.item.qa.length; i++ ) {
				let item = this.item.qa[i];
				els.push({
					tag: 'div',
					className: 'section',
					attr: {
						itemscope: '',
						itemprop: 'mainEntity',
						itemtype: 'https://schema.org/Question'
					},
					id: 'section-' + i,
					els: [
						{
							tag: 'input',
							type: 'checkbox',
							name: 'tab',
							id: 'tab-' + i
						},
						{
							tag: 'label',
							attr: {
								for: 'tab-' + i,
								itemprop: 'name'
							},
							els: [
								{
									tag: 'h3',
									text: item.question
								},
								{
									tag: 'div',
									className: 'toggle'
								}
							]
						},
						{
							tag: 'div',
							className: 'tabContent',
							attr: {
								itemscope: '',
								itemprop: 'acceptedAnswer',
								itemtype: 'https://schema.org/Answer'
							},
							els: [
								{
									tag: 'div',
									attr: {
										itemprop: 'text'
									},
									innerHTML: item.answer
								}
							]
						}
					]
				});
			}

			mkE({
				tag: 'div',
				className: 'container FAQ',
				attr: {
					'itemscope': '',
					'itemtype': 'https://schema.org/FAQPage'
				},
				els: [
					{
						tag: 'h2',
						className: 'h1',
						text: D.Lang.get('blog.faq.title')
					},
					{
						tag: 'div',
						className: 'faq-content',
						els: [
							{
								tag: 'div',
								className: 'accordion',
								els: els
							}
						]
					}
				]
			}).append(this.node);
		},

		shareUrl( source ) {
			const get = new Get('https://www.roadgames.com/' + D.LANG + '' + this.item.url);
			get.add('utm_source', source);
			get.add('utm_medium', 'social');
			get.add('utm_campaign', 'blog-share');
			get.add('utm_content', this.item.id);
			return get.toUrl();
		},

		_shareUrlFacebook() {
			const get = new Get('https://www.facebook.com/sharer/sharer.php');
			get.add('u', this.shareUrl('facebook.com'));
			return get.toUrl();
		},

		_shareUrlDraugiem() {
			const get = new Get('https://www.draugiem.lv/say/ext/add.php');
			get.add('title', '');
			get.add('link', this.shareUrl('draugiem.lv'));
			return get.toUrl();
		},

		_shareUrlTwitter() {
			const get = new Get('https://twitter.com/share');
			get.add('text', '');
			// get.add('hashtags', '');
			get.add('url', this.shareUrl('twitter.com'));
			return get.toUrl();
		},

		_shareUrlLinkedIn() {
			const get = new Get('https://www.linkedin.com/sharing/share-offsite/');
			get.add('url', this.shareUrl('linkedin.com'));
			return get.toUrl();
		}
	},
	mkE.Base
);

//@todo move to api
D.Blog.NewsLetterForm = Class(
	/**
	 * @lends {D.Blog.NewsLetterForm#}
	 */
	{
		__construct( hasContainer ) {
			this.node = mkE({
				tag: 'div',
				className: 'newsletter-signup',
				id: 'newsletter',
				els: [
					{
						tag: 'div',
						className: hasContainer ? 'container' : '',
						els: [
							{
								tag: 'div',
								className: 'newsletter-text',
								els: [
									{
										tag: 'h3',
										text: D.Lang.get('blog.newsletter.title')
									},
									{
										tag: 'p',
										text: D.Lang.get('blog.newsletter.text')
									}
								]
							},
							{
								tag: 'div',
								className: 'newsletter-form',
								els: [
									{
										tag: 'div',
										className: 'newsletter-input',
										els: [
											this._input = new T.Form.Input({
												placeholder: D.Lang.get('blog.newsletter.email_placeholder')
											})
										]
									},
									{
										tag: 'div',
										className: 'newsletter-button',
										els: [
											this._button = mkE({
												tag: 'div',
												className: 'button button-turquoise',
												text: D.Lang.get('blog.newsletter.subscribe'),
												onclick: this._onSubmit
											})
										]
									}
								]
							}
						]
					}
				]
			});
		},

		_onSubmit() {
			if( this._isSubmitting || this._isDisabled ) {
				return;
			}
			this._isSubmitting = true;
			new RPC('/api/web_rpc.php').send('blogSubscribe', {
				email: this._input.value()
			}, this._onSubmitRe);
		},

		_onSubmitRe( re ) {
			this._isSubmitting = false;
			if( re.ok ) {
				this._isDisabled = true;
				addClassName(this._button, 'button-disabled');
				mkE({
					tag: 'div',
					className: 'input-success',
					text: D.Lang.get('blog.newsletter.success')
				}).replace(this._input.node);
			} else {
				this._input.error(D.Lang.get('blog.newsletter.error'));
			}
		}
	},
	mkE.Base
);

D.Blog.ContactForm = Class(
	/**
	 * @lends {D.Blog.ContactForm#}
	 */
	{
		_inputs: {},

		__construct() {
			this.node = mkE({
				tag: 'div',
				className: 'contact-form',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('contacts.form.title')
					}
				]
			});
			this._drawForm();
			D.onCaptcha(this._onCaptcha);
		},

		_drawForm() {
			mkE({
				tag: 'form',
				onsubmit: this._submitForm,
				els: [
					{
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-50',
								els: [
									this._inputs.name = new T.Form.Input({
										caption: D.Lang.get('contacts.form.name')
									})
								]
							},
							{
								tag: 'div',
								className: 'col col-50',
								els: [
									this._inputs.email = new T.Form.Input({
										caption: D.Lang.get('contacts.form.email'),
										type: 'email'
									})
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'row',
						els: [
							{
								tag: 'div',
								className: 'col col-100',
								els: [
									this._inputs.message = new T.Form.TextArea({
										caption: D.Lang.get('contacts.form.message'),
										attr: {
											rows: 4
										}
									})
								]
							}
						]
					},
					this._captchaDiv = mkE({
						tag: 'div'
					}),
					this._button = mkE({
						tag: 'button',
						className: 'button button-pink button-large',
						text: D.Lang.get('contacts.form.submit')
					})
				]
			}).append(this.node);
		},

		_onCaptcha() {
			this._captcha = grecaptcha.render(
				this._captchaDiv,
				{
					sitekey: '6LdvnYEUAAAAADdoVoY8ZJp9lSLLl1gP_meCVUBD',
					theme: 'light',
					size: 'invisible',
					callback: this._submit
				}
			);
			mkE({
				tag: 'div',
				className: 'captcha-policy',
				els: [
					'This site is protected by reCAPTCHA and the Google ',
					{tag: 'a', href: 'https://policies.google.com/privacy', text: 'Privacy Policy', target: '_blank'},
					' and ',
					{tag: 'a', href: 'https://policies.google.com/terms', text: 'Terms of Service', target: '_blank'},
					' apply.'
				]
			}).append(this.node);
		},

		_submitForm() {
			grecaptcha.reset(this._captcha);
			grecaptcha.execute(this._captcha);
			return false;
		},

		_submit() {
			if( this._isSubmitting || this._isSubmitted ) {
				return;
			}
			this._isSubmitting = true;
			new RPC('/api/web_rpc.php').send('submitContactForm', this._getData(), this._onSubmit);
			return false;
		},

		_getData() {
			return {
				name: this._inputs.name.value(),
				email: this._inputs.email.value(),
				message: this._inputs.message.value()
			};
		},

		_onSubmit( re ) {
			this._isSubmitting = false;
			for( let i in this._inputs ) {
				if( this._inputs.hasOwnProperty(i) ) {
					this._inputs[i].error(null);
				}
			}
			if( re.errors ) {
				this._onError(re);
				return;
			} else if( re.ok ) {
				this._onSent();
			}
			this._isSubmitted = true;
		},

		_onError( re ) {
			for( let i in re.errors ) {
				if( re.errors.hasOwnProperty(i) ) {
					this._inputs[i].error(D.Lang.get('contacts.form.errors.' + i));
				}
			}
		},

		_onSent() {
			if( this._inputs.how ) {
				this._inputs.how.success(mkE({
					tag: 'span',
					innerHTML: D.Lang.get('contacts.form.ok')
				}));
			} else {
				this._inputs.message.success(mkE({
					tag: 'span',
					innerHTML: D.Lang.get('contacts.form.ok')
				}));
			}
			for( let i in this._inputs ) {
				if( this._inputs.hasOwnProperty(i) ) {
					const input = this._inputs[i];
					if( input instanceof T.Form.Phone ) {
						input.value('371', '');
					} else {
						input.value('');
					}
				}
			}
			if( window.ga ) {
				ga('send', {
					hitType: 'event',
					eventCategory: 'Form',
					eventAction: 'Submit',
					eventLabel: 'blog-contacts'
				});
			}
			const get = new Get();
			get.add('send-success', '');
			Section.replaceUrl(get.toUrl());
		}
	},
	mkE.Base
);